const isStage = window.location.host.includes("stage");
export const fakturyUrl = isStage ? "https://raks-faktury-stage.azurewebsites.net/app" : "https://faktury.raks.pl/app";
export const brunetUrl = isStage ? "https://brunetstage.raks.pl/app" : "https://brunet.raks.pl/app";
